// Forward / reverse geocoding via OpenStreetMap Nominatim.
//
// PRIVACY NOTE: these functions send data to an external service —
//   • geocodeAddress: the typed address string
//   • reverseGeocode: a set of coordinates
// They are used ONLY by the Video Canvass Tracker and Area Search Coordinator,
// which are explicitly labeled in-app as shared, server-backed tools. Do not
// use these in the local-only tools. Nominatim asks for <= 1 request/second;
// callers should debounce.

const BASE = 'https://nominatim.openstreetmap.org';

// Resolve a typed address to a list of candidate { lat, lng, label } points.
export async function geocodeAddress(query, { limit = 5, signal } = {}) {
  const q = (query || '').trim();
  if (!q) return [];
  const url = `${BASE}/search?format=jsonv2&addressdetails=0&limit=${limit}&q=${encodeURIComponent(q)}`;
  const res = await fetch(url, { signal, headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`Geocoding failed (${res.status})`);
  const data = await res.json();
  return (Array.isArray(data) ? data : [])
    .map(d => ({ lat: parseFloat(d.lat), lng: parseFloat(d.lon), label: d.display_name || '' }))
    .filter(d => !isNaN(d.lat) && !isNaN(d.lng));
}

// Best-effort street label for a dropped pin. Returns '' on any failure so the
// caller can silently fall back to raw coordinates.
export async function reverseGeocode(lat, lng, { signal } = {}) {
  if (lat == null || lng == null) return '';
  const url = `${BASE}/reverse?format=jsonv2&lat=${lat}&lon=${lng}`;
  try {
    const res = await fetch(url, { signal, headers: { Accept: 'application/json' } });
    if (!res.ok) return '';
    const d = await res.json();
    return d.display_name || '';
  } catch {
    return '';
  }
}
